import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 overflow-hidden px-3 py-1.5 text-sm text-popover-foreground",
      "rounded-md relative isolate box-border border-[0.5px] border-transparent bg-secondary",
      "before:inset-0 before:border-t-[0.5px] before:border-white/20 before:h-full before:w-full before:absolute before:rounded-[inherit] before:bg-gradient-to-b before:from-white/[0.03] before:to-black/[0.03] before:pointer-events-none",
      "dark:before:top-[-0.5px] dark:before:w-[calc(100%+1px)] dark:before:start-[-0.5px] dark:before:end-[-0.5px]",
      "after:absolute after:inset-[-0.5px] after:rounded-[inherit] after:pointer-events-none after:-z-10 after:border-[0.5px] after:border-black/20 dark:after:border-white/10 after:shadow-md",
      "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    )}
    {...props}
  />
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
